import React from "react"

import Footer from "~components/shared/layout/footer"
import LandingPageHero from "~components/pages/try/shared/hero"
import LandingHowItWorks from "~components/pages/try/shared/how-it-works"
import LandingTestimonial from "~components/pages/try/shared/testimonial"
import LandingBenefits from "~components/pages/try/shared/benefits"
import SEO from "~components/shared/SEO"

import EzyVetGlobalSupportGroupVidyardVideo from "~components/pages/try/ezyvet-gsg/vidyard-video"
import EzyVetGlobalSupportGroupPartnerInfo from "~components/pages/try/ezyvet-gsg/partner-info"
import socialImage from "../../images/socials/try-ezyvet-support-group.png"

export default function LandingPage() {
    return (
        <>
            <LandingPageHero
                productMock={<EzyVetGlobalSupportGroupVidyardVideo />}
                partnerInfo={<EzyVetGlobalSupportGroupPartnerInfo />}
            />
            <LandingHowItWorks />
            <LandingTestimonial />
            <LandingBenefits />
            <Footer />
        </>
    )
}

export const Head = () => (
    <SEO
        title="Unofficial ezyVet Global Support Group Partnership"
        imageUrl={socialImage}
    >
        <script
            type="text/javascript"
            async
            src="https://play.vidyard.com/embed/v4.js"
        ></script>
    </SEO>
)
